module.exports = __webpack_public_path__ + "img/264-6.595ed57e.jpg";